var _rect, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _rect2, _rect3, _rect4, _rect5, _rect6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCursosDeEntrenamiento(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 72,
    viewBox: "0 0 68 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 50.8643,
    height: 60.3043,
    rx: 5,
    fill: "white",
    fillOpacity: 0.97,
    stroke: "#9B5AE6",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 7.60791,
    y1: 10.3281,
    x2: 44.3121,
    y2: 10.3281,
    stroke: "#9B5AE6",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 7.60791,
    y1: 10.3281,
    x2: 44.3121,
    y2: 10.3281,
    stroke: "#9B5AE6",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 7.60791,
    y1: 10.3281,
    x2: 44.3121,
    y2: 10.3281,
    stroke: "#9B5AE6",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 7.60791,
    y1: 32.9843,
    x2: 44.3121,
    y2: 32.9843,
    stroke: "#9B5AE6",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 7.60791,
    y1: 32.9843,
    x2: 44.3121,
    y2: 32.9843,
    stroke: "#9B5AE6",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 7.60791,
    y1: 32.9843,
    x2: 44.3121,
    y2: 32.9843,
    stroke: "#9B5AE6",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 7.60791,
    y1: 25.4322,
    x2: 44.3121,
    y2: 25.4322,
    stroke: "#9B5AE6",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 7.60791,
    y1: 25.4322,
    x2: 44.3121,
    y2: 25.4322,
    stroke: "#9B5AE6",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 7.60791,
    y1: 25.4322,
    x2: 44.3121,
    y2: 25.4322,
    stroke: "#9B5AE6",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 7.60791,
    y1: 17.8801,
    x2: 44.3121,
    y2: 17.8801,
    stroke: "#9B5AE6",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 7.60791,
    y1: 17.8801,
    x2: 44.3121,
    y2: 17.8801,
    stroke: "#9B5AE6",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 7.60791,
    y1: 17.8801,
    x2: 44.3121,
    y2: 17.8801,
    stroke: "#9B5AE6",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 52.6499,
    y: 35.9318,
    width: 6.45535,
    height: 29.6946,
    transform: "rotate(46.2707 52.6499 35.9318)",
    fill: "#9B5AE6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 49.2007,
    y: 26.7237,
    width: 23.8848,
    height: 7.84747,
    rx: 3.92374,
    transform: "rotate(46.2707 49.2007 26.7237)",
    fill: "#9B5AE6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 54.2515,
    y: 25.4662,
    width: 18.7205,
    height: 3.87321,
    rx: 1.9366,
    transform: "rotate(46.2707 54.2515 25.4662)",
    fill: "#9B5AE6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 38.6558,
    y: 69.8645,
    width: 23.8848,
    height: 8.54455,
    rx: 4.27228,
    transform: "rotate(-133.729 38.6558 69.8645)",
    fill: "#9B5AE6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 33.606,
    y: 71.1221,
    width: 18.7205,
    height: 3.87321,
    rx: 1.9366,
    transform: "rotate(-133.729 33.606 71.1221)",
    fill: "#9B5AE6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCursosDeEntrenamiento);
export default __webpack_public_path__ + "static/media/cursos_de_entrenamiento.f93cd1a5a30e7fd7260f9a9af5b88752.svg";
export { ForwardRef as ReactComponent };